import { Injectable, Injector } from "@angular/core";
import { TrackingDispatchService } from "./tracking-dispatch.service";
import { NavigationEventRequest, NavigationTriggerType } from "./tracking.models";

// Re-exported so the ~24 call sites that import NavigationTriggerType from here keep working. The
// definitions moved to tracking.models.ts to break an import cycle with TrackingDispatchService.
export { NavigationEventRequest, NavigationTriggerType };

/**
 * Records the app's two navigation surfaces: the persistent bottom nav bar (ViaNavigation) and
 * in-page links/cards/buttons that change screen (InPageNav). Dialogs/modals don't call this - the
 * route doesn't change, so they're not navigation. See "Full App Event-Tracking Taxonomy"
 * (Confluence FLIP-110919682) Section 1.
 *
 * Since FLIP-213 this only queues onto TrackingDispatchService, which batches everything fired in
 * the same tick into one POST to api/Tracking/Track. The public signature is unchanged, so no call
 * site needed touching.
 */
@Injectable({
  providedIn: "root",
})
export class NavigationTrackingService {
  // Resolved lazily via Injector so a component injecting only this service doesn't drag
  // UserService (a TrackingDispatchService dependency) into its construction order.
  constructor(private injector: Injector) {}

  /** Fire-and-forget: tracking must never block or break navigation if it fails. */
  track(event: NavigationEventRequest): void {
    this.injector.get(TrackingDispatchService).queueNavigation(event);
  }
}
